import { Button } from "@mui/material";
import React from "react";

function ButtonCompo({ variant, color, children, startIcon, ...props }) {
  return (
    <Button
      variant={variant}
      startIcon={startIcon}
      color={color}
      className="!font-medium"
      {...props}
    >
      {children}
    </Button>
  );
}

export default ButtonCompo;
